var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexacoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_2948)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_921_2948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76446 0.83579C8.86121 0.307624 10.1388 0.307624 11.2355 0.83579L15.1919 2.74106C16.2886 3.26922 17.0852 4.26807 17.356 5.45485L18.3332 9.73595C18.604 10.9227 18.3198 12.1683 17.5608 13.12L14.8229 16.5532C14.0639 17.5049 12.9129 18.0592 11.6956 18.0592H7.3044C6.0871 18.0592 4.93605 17.5049 4.17708 16.5532L1.43921 13.12C0.680239 12.1683 0.395952 10.9227 0.666827 9.73595L1.64396 5.45485C1.91483 4.26807 2.71139 3.26922 3.80814 2.74106L7.76446 0.83579Z",
    fill: "url(#paint0_linear_921_2948)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.98141 1.28627C8.94106 0.824129 10.0589 0.824129 11.0186 1.28627L14.9749 3.19154C15.9346 3.65369 16.6316 4.52768 16.8686 5.56611L17.8457 9.84721C18.0827 10.8856 17.834 11.9755 17.1699 12.8082L14.432 16.2414C13.7679 17.0742 12.7607 17.5592 11.6956 17.5592H7.3044C6.23927 17.5592 5.23209 17.0742 4.56799 16.2414L1.83013 12.8082C1.16603 11.9755 0.917275 10.8856 1.15429 9.84721L2.13142 5.56611C2.36844 4.52768 3.06542 3.65369 4.02508 3.19154L7.98141 1.28627Z",
    stroke: "#F29106",
    strokeOpacity: 0.33
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_921_2948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2988 9.06057C11.3963 9.06057 11.4654 9.04197 11.5061 9.00477C11.5549 8.96757 11.5793 8.89317 11.5793 8.78157V6.88436C11.5793 6.59606 11.563 6.34961 11.5305 6.14501C11.5061 5.94041 11.4533 5.77301 11.372 5.6428C11.2907 5.5126 11.1728 5.41495 11.0183 5.34985C10.872 5.27545 10.6728 5.22895 10.4207 5.21035C10.372 5.21035 10.3354 5.1871 10.311 5.1406C10.2866 5.0848 10.2744 5.029 10.2744 4.9732C10.2744 4.9174 10.2866 4.86625 10.311 4.81975C10.3354 4.77325 10.372 4.75 10.4207 4.75C10.6809 4.75 10.9776 4.76395 11.311 4.79185C11.6443 4.81975 11.9573 4.8337 12.25 4.8337C12.4207 4.8337 12.5793 4.82905 12.7256 4.81975C12.8801 4.81045 13.0264 4.80115 13.1646 4.79185C13.311 4.78255 13.4573 4.77325 13.6037 4.76395C13.75 4.75465 13.9085 4.75 14.0793 4.75C14.128 4.75 14.1606 4.77325 14.1768 4.81975C14.2012 4.86625 14.2093 4.9174 14.2012 4.9732C14.2012 5.029 14.189 5.0848 14.1646 5.1406C14.1402 5.1871 14.1077 5.21035 14.0671 5.21035C13.815 5.22895 13.6118 5.2708 13.4573 5.3359C13.3028 5.3917 13.185 5.4847 13.1037 5.6149C13.0224 5.7358 12.9695 5.89856 12.9451 6.10316C12.9207 6.30776 12.9085 6.56816 12.9085 6.88436V12.3528C12.9085 12.6597 12.9248 12.9015 12.9573 13.0782C12.9898 13.2456 13.0467 13.3804 13.128 13.4827C13.2175 13.5757 13.3394 13.6455 13.4939 13.692C13.6484 13.7292 13.8476 13.7617 14.0915 13.7896C14.1402 13.7989 14.1768 13.8268 14.2012 13.8733C14.2337 13.9198 14.25 13.971 14.25 14.0268C14.25 14.0826 14.2337 14.1337 14.2012 14.1803C14.1768 14.2268 14.1362 14.25 14.0793 14.25C13.7541 14.25 13.4411 14.2314 13.1402 14.1942C12.8476 14.157 12.5549 14.1384 12.2622 14.1384C11.9533 14.1384 11.6321 14.157 11.2988 14.1942C10.9736 14.2314 10.6768 14.25 10.4085 14.25C10.3598 14.25 10.3232 14.2268 10.2988 14.1803C10.2744 14.1337 10.2622 14.0826 10.2622 14.0268C10.2622 13.971 10.2744 13.9198 10.2988 13.8733C10.3232 13.8268 10.3598 13.7989 10.4085 13.7896C10.6606 13.7617 10.8598 13.7292 11.0061 13.692C11.1606 13.6455 11.2785 13.5757 11.3598 13.4827C11.4492 13.3804 11.5061 13.2456 11.5305 13.0782C11.563 12.9015 11.5793 12.6597 11.5793 12.3528V10.0371C11.5793 9.79528 11.4898 9.67438 11.311 9.67438H7.66463C7.48577 9.67438 7.39634 9.76738 7.39634 9.95338V12.3528C7.39634 12.6597 7.4126 12.9015 7.44512 13.0782C7.47764 13.2456 7.53455 13.3804 7.61585 13.4827C7.70528 13.5757 7.82724 13.6455 7.98171 13.692C8.13618 13.7292 8.33537 13.7617 8.57927 13.7896C8.62805 13.7989 8.66463 13.8268 8.68902 13.8733C8.72154 13.9198 8.7378 13.971 8.7378 14.0268C8.7378 14.0826 8.72154 14.1337 8.68902 14.1803C8.66463 14.2268 8.62398 14.25 8.56707 14.25C8.24187 14.25 7.92886 14.2314 7.62805 14.1942C7.33537 14.157 7.04268 14.1384 6.75 14.1384C6.44106 14.1384 6.11992 14.157 5.78659 14.1942C5.46138 14.2314 5.16463 14.25 4.89634 14.25C4.84756 14.25 4.81098 14.2268 4.78659 14.1803C4.7622 14.1337 4.75 14.0826 4.75 14.0268C4.75 13.971 4.7622 13.9198 4.78659 13.8733C4.81098 13.8268 4.84756 13.7989 4.89634 13.7896C5.14837 13.7617 5.34756 13.7292 5.4939 13.692C5.64837 13.6455 5.76626 13.5757 5.84756 13.4827C5.93699 13.3804 5.9939 13.2456 6.01829 13.0782C6.05081 12.9015 6.06707 12.6597 6.06707 12.3528V6.88436C6.06707 6.59606 6.05081 6.34961 6.01829 6.14501C5.9939 5.94041 5.94106 5.77301 5.85976 5.6428C5.77846 5.5126 5.66057 5.41495 5.5061 5.34985C5.35976 5.27545 5.16057 5.22895 4.90854 5.21035C4.85976 5.21035 4.82317 5.1871 4.79878 5.1406C4.77439 5.0848 4.7622 5.029 4.7622 4.9732C4.7622 4.9174 4.77439 4.86625 4.79878 4.81975C4.82317 4.77325 4.85976 4.75 4.90854 4.75C5.1687 4.75 5.46545 4.76395 5.79878 4.79185C6.13211 4.81975 6.44512 4.8337 6.7378 4.8337C6.90854 4.8337 7.06707 4.82905 7.21341 4.81975C7.36789 4.81045 7.51423 4.80115 7.65244 4.79185C7.79878 4.78255 7.94512 4.77325 8.09146 4.76395C8.2378 4.75465 8.39634 4.75 8.56707 4.75C8.61585 4.75 8.64837 4.77325 8.66463 4.81975C8.68902 4.86625 8.69715 4.9174 8.68902 4.9732C8.68902 5.029 8.67683 5.0848 8.65244 5.1406C8.62805 5.1871 8.59553 5.21035 8.55488 5.21035C8.30285 5.22895 8.09959 5.2708 7.94512 5.3359C7.79065 5.3917 7.67276 5.4847 7.59146 5.6149C7.51016 5.7358 7.45732 5.89856 7.43293 6.10316C7.40854 6.30776 7.39634 6.56816 7.39634 6.88436V8.78157C7.39634 8.96757 7.48577 9.06057 7.66463 9.06057H11.2988Z",
    fill: "#3E1C25"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_921_2948",
    x: 0.566406,
    y: 0.439453,
    width: 17.8672,
    height: 17.6201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_921_2948"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_921_2948",
    x: 4.75,
    y: 4.75,
    width: 9.5,
    height: 9.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_921_2948"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_921_2948",
    x1: 1.9,
    y1: 2.6125,
    x2: 16.625,
    y2: 15.9125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200940",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF7300",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#FF9D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833637,
    stopColor: "#FF7300",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200940",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_2948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexacoinIcon);
export default __webpack_public_path__ + "static/media/HexacoinIcon.b58352e8114daa229992db9812c4b147.svg";
export { ForwardRef as ReactComponent };